import { createApp } from 'vue'
import { createRouter, createWebHistory } from 'vue-router'
import App from './App.vue'
import i18n from './i18n'
import adminRoutes from './router/admin'  // 導入管理端路由
import router from './router/admin' // 确保这里导入的是正确的路由文件
import {
  Button,
  Cell,
  CellGroup,
  NavBar,
  Tabbar,
  TabbarItem,
  Tab,
  Tabs,
  Field,
  Switch,
  Radio,
  RadioGroup,
  Stepper,
  Picker,
  Popup,
  Form,
  Checkbox,
  DropdownMenu,
  DropdownItem,
  Search,
  List,
  Tag,
  Grid,
  GridItem,
  SwipeCell,
  Dialog,
  Image,
  Toast,
  Col,
  Row,
  Icon
} from 'vant'
import 'vant/lib/index.css'
import './assets/styles/global.css'

// 創建路由實例
const routerInstance = createRouter({
  history: createWebHistory(),
  routes: [
    ...adminRoutes,  // 添加管理端路由
    // 其他路由配置...
  ]
})

const app = createApp(App)

// 從 localStorage 讀取保存的語言設置
const savedLanguage = localStorage.getItem('language')
if (savedLanguage) {
  i18n.global.locale.value = savedLanguage
}

// 路由守衛
routerInstance.beforeEach((to, from, next) => {
  if (to.meta.requiresAuth && to.path.startsWith('/admin')) {
    const adminToken = localStorage.getItem('admin_token')
    if (!adminToken) {
      next('/admin/login')
      return
    }
  }
  next()
})

app.use(routerInstance)
app.use(i18n)

// 註冊 Vant 組件
app.use(Button)
app.use(Cell)
app.use(CellGroup)
app.use(NavBar)
app.use(Tabbar)
app.use(TabbarItem)
app.use(Tab)
app.use(Tabs)
app.use(Field)
app.use(Switch)
app.use(Radio)
app.use(RadioGroup)
app.use(Stepper)
app.use(Picker)
app.use(Popup)
app.use(Form)
app.use(Checkbox)
app.use(DropdownMenu)
app.use(DropdownItem)
app.use(Search)
app.use(List)
app.use(Tag)
app.use(Grid)
app.use(GridItem)
app.use(SwipeCell)
app.use(Dialog)
app.use(Image)
app.use(Toast)
app.use(Col)
app.use(Row)
app.use(Icon)
app.mount('#app') 